import Vue from 'vue';
import VTooltip from 'v-tooltip';
import VueRouter from 'vue-router';
import App from './App.vue';
import Loading from 'vue-loading-overlay';
import VueToggles from 'vue-toggles';
import { has, get } from 'lodash';
import 'vue-loading-overlay/dist/vue-loading.css';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import VueTypedJs from 'vue-typed-js';
import VueTabs from 'vue-nav-tabs';
import 'vue-nav-tabs/themes/vue-tabs.css';
import VueQrcode from '@chenfengyuan/vue-qrcode';

// Store from Vuex
import store from './store/store';

// LightBootstrap plugin
import LightBootstrap from './light-bootstrap-main';

// router setup
import routes from './routes/routes';

import './registerServiceWorker';
// plugin setup
Vue.use(VueRouter);
Vue.use(LightBootstrap);
Vue.use(Loading);
Vue.use(VTooltip);
Vue.use(VueAwesomeSwiper);
Vue.use(VueToggles);
Vue.use(VueTypedJs);
Vue.use(VueTabs);
Vue.use(VueQrcode);

// configure router
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  linkActiveClass: 'nav-item active',
  linkExactActiveClass: 'active',
  routes,
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  }
});

router.beforeEach((to, from, next) => {
  if (to.name === 'home') {
    const hasUserLogged =
      has(store, 'state.usuario') || localStorage.getItem('userData');
    if (hasUserLogged) next('/portal/perfil');
  }
  if (get(to, 'meta.requiresAuth')) {
    // rota privada
    const hasUserLogged =
      has(store, 'state.usuario') || localStorage.getItem('userData');
    if (!hasUserLogged) {
      // não logado
      next('/');
      return;
    }
    let userLogged;
    if (!has(store, 'state.usuario')) {
      // não está no store do vuex, mas tem no localstorage
      userLogged = JSON.parse(localStorage.getItem('userData'));
    }
    //administrador tem acesso a todas as rotas
    const exclusiveRoutesToAdministrador = [
      'FinanceiroCliente',
      'FinanceiroGeral',
      'Vendedores'
    ];
    if (
      exclusiveRoutesToAdministrador.includes(to.name) &&
      userLogged.tipoUsuario !== 'administrador'
    ) {
      next('/');
    } else if (
      userLogged.tipoUsuario !== 'administrador' &&
      userLogged.tipoUsuario !== 'colaborador'
    ) {
      let enabledRoutes = [];
      if (userLogged.tipoUsuario === 'vendedor') {
        enabledRoutes = [
          'cadastrarProposta',
          'downloads',
          'crm',
          'linhaDotempoCrm',
          'produtos'
        ];
      } else if (userLogged.tipoUsuario === 'parceiro') {
        enabledRoutes = ['servicos', 'produtos', 'downloads'];
      }

      //common route
      enabledRoutes.push('perfil');

      if (!enabledRoutes.includes(to.name)) {
        next('/');
        return;
      }
    }
  }
  //if jump the if, is a public router
  next();
});

/* eslint-disable no-new */
const vue = new Vue({
  store,
  el: '#app',
  render: h => h(App),
  router
});

export default vue;
